import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

(function () {
    const viewMoreLists = document.querySelectorAll('[data-view-more-list]');

    if (!viewMoreLists.length) {
        return;
    }

    viewMoreLists.forEach((viewMoreList) => {
        let clickTarget = <HTMLElement>viewMoreList.getElementsByTagName('button')[0];

        let staggerItems = viewMoreList.querySelectorAll('[data-report-list-hidden]');

        const textContent = <HTMLElement>clickTarget.querySelectorAll('.view-more-button__text')[0];
        const closeText = clickTarget.getAttribute('data-close-text');
        const moreText = clickTarget.getAttribute('data-more-text');

        clickTarget.setAttribute('aria-expanded', 'false');

        const tl = gsap.timeline({
            paused: true,
            onComplete: () => {
                clickTarget.classList.add('view-more-button--open');
                clickTarget.setAttribute('aria-expanded', 'true');
                textContent.innerText = closeText;
            },
            onReverseComplete: () => {
                clickTarget.classList.remove('view-more-button--open');
                clickTarget.setAttribute('aria-expanded', 'false');
                gsap.to(window, { duration: 0, scrollTo: { y: clickTarget, offsetY: 200 } });
                textContent.innerText = moreText;
            },
        });

        tl.fromTo(
            staggerItems,
            { yPercent: -25, opacity: 0, display: 'none' },
            {
                duration: 0.5,
                stagger: 0.025,
                display: 'grid',
                yPercent: 0,
                opacity: 1,
                ease: 'expo.inOut',
            }
        );

        clickTarget.onclick = function () {
            if (clickTarget.classList.contains('view-more-button--open')) {
                tl.timeScale(1.25).reverse();
            } else {
                clickTarget.classList.add('view-more-button--open');
                tl.timeScale(1).play(0);
            }
        };
    });
})();
